// Apply catalogue visibility before Shopify counts and paginates full search.
// Predictive requests keep their original query and typo tolerance.
const SUFFIX = ') AND -tag:outlet AND -tag:document-vault AND -tag:internal';

export function customerSearchTerms(query) {
  const value = String(query || '').trim();
  return value.startsWith('(') && value.endsWith(SUFFIX) ? value.slice(1, -SUFFIX.length) : value;
}

export function catalogueSearchQuery(query) {
  const terms = customerSearchTerms(query);
  return terms ? `(${terms}${SUFFIX}` : '';
}

export function catalogueSearchURL(url, query) {
  const target = new URL(url, window.location.origin);
  target.searchParams.set('q', catalogueSearchQuery(query ?? target.searchParams.get('q')));
  target.searchParams.set('type', 'product');
  return target;
}

// Also cover saved links and external links that enter with an unfiltered query.
if (/\/search\/?$/.test(window.location.pathname)) {
  const current = new URL(window.location.href);
  if (current.searchParams.has('q')) {
    const target = catalogueSearchURL(current);
    if (current.searchParams.get('q') !== target.searchParams.get('q') || current.searchParams.get('type') !== 'product') {
      window.location.replace(target.href);
    }
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !/\/search\/?$/.test(new URL(form.action).pathname)) return;
  const input = form.querySelector('input[name="q"]');
  if (!input) return;
  event.preventDefault();
  const target = new URL(form.action);
  for (const [key, value] of new FormData(form)) target.searchParams.set(key, String(value));
  window.location.assign(catalogueSearchURL(target, input.value).href);
}, { capture: true });
